class BackgroundComposer {
    constructor(layers) {
        this._layers = [...layers];
        this._weights = [];

        this._layerTypes = [];
        for (let [i, layer] of layers.entries()) {
            this._layerTypes[i] = 'none';
        }
    }

    setLayerType(i, type) {
        this._layerTypes[i] = type;

        this._update();
    }

    setWeights(weights) {
        for (let i = 0; i < this._layers.length; i++) {
            this._weights[i] = i < weights.length ? weights[i] : 0;
        }

        this._update();
    }

    _update() {
        let domLayers = [], webglLayers = [];
        for (let i = 0; i < this._layers.length; i++) {
            let layer = this._layers[i];
            let type = this._layerTypes[i];

            if (type === 'panorama') {
                webglLayers.push(i);
            } else {
                domLayers.push(i);
            }
        }

        let layerIds = [...domLayers, ...webglLayers];
        let layers = [], weights = [];
        for (let i of layerIds) {
            layers.push(this._layers[i]);
            weights.push(this._weights[i]);
        }

        //let StartRenderOrder = -2;

        let opacities = getComposedLayerOpacities(weights);
        for (let i = 0; i < layers.length; i++) {
            let layer = layers[i];
            let opacity = opacities[i];
            //layer.setRenderOrder(StartRenderOrder+i);
            layer.opacity = opacity;
        }
    }
}

function getComposedLayerOpacities(finalOpacities) {
    let ownOpacities = [];

    let totalPart = 0;
    for (let finalOpacity of finalOpacities) {
        totalPart += finalOpacity;
    }

    for (let i = finalOpacities.length-1; i >= 0; i--) {
        let finalOpacity = finalOpacities[i];

        let ownOpacity = finalOpacity/totalPart;
        if (isNaN(ownOpacity)) {
            ownOpacity = 0;
        }

        ownOpacities[i] = ownOpacity;
        totalPart -= finalOpacity;
    }

    return ownOpacities;
}

export default BackgroundComposer;
export { BackgroundComposer };
